<template>
<div>



  <div class="header css-margin-top">
    <p class="title">{{title}}</p>
    <div v-if="title==='工艺曲线'" class="state" :class="{'state-off':deviceInfo.device_status !=='在线'}"></div>
    <div v-if="title==='工艺曲线'" class="device-statue">
      {{deviceInfo.device_status}}
    </div>
    <!-- <el-breadcrumb class="css-margin-top" separator=">">
                  <el-breadcrumb-item v-for ="item in routeList" :to="{ path: item.path}" :key="item.path">{{item.name}}</el-breadcrumb-item>
              </el-breadcrumb> -->

  </div>

  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: 'page-header',
  data() {
    return {
      title: '实时数据',
      routeList: []
    }
  },
  computed: {
    ...mapState({
      deviceInfo: state => state.deviceInfo

    })

  },
  created() {
    this.showTitle()

  },
  mounted() {

  },
  methods: {
    showTitle() {
      this.routeList = this.$route.matched
      this.title = this.$route.name
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
}

.header .title {
  font-size: 0.3rem;
  color: #0056b8;
}

.device-statue {
  margin-left: 4px;
  font-size: 0.18rem;
}

.state {
  margin-left: 25px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #39d649;
}

.state-off {
  background: red
}

h1 {
  color: #0082ff
}
    @media screen and (max-width: 900px) {
        .header .title {
            font-size: 0.23rem;
        }
    }
</style>



// WEBPACK FOOTER //
// header.vue?1a919ef6